import { AddSearchCriteria } from "types/addSearchCriteriaFunction";
import { ContentCategory } from "types/appConfigV2";
import { AutoSuggestValue } from "types/autoSuggestValue";
import { Folder } from "types/qbank/folder";
import { PropertyCriteria } from "types/qbank/propertyCriteria";
import { SearchModel, SearchModelEnum } from "types/qbank/searchModel";
import { SortField } from '../types/qbank/searchSortField'
import { SortDirection } from '../types/qbank/searchSortDirection'

type SEARCH_CHANGE_CATEGORY = "CHANGE_CATEGORY"
type SEARCH_CHANGE_FOLDER = "CHANGE_FOLDER"
type SEARCH_ADD_FILTER = "ADD_FILTER"
type SEARCH_REMOVE_FILTER = "REMOVE_FILTER"
type SEARCH_REMOVE_ALL_FILTER = "REMOVE_ALL_FILTER"
type SEARCH_ADD_SORT = "ADD_SORT"

type ChangeCategory = {
  type: SEARCH_CHANGE_CATEGORY,
  payload: ContentCategory
}
type ChangeFolder = {
  type: SEARCH_CHANGE_FOLDER,
  payload: Folder
}

type AddFilter = {
  type: SEARCH_ADD_FILTER,
  payload: AddSearchCriteria
}

type RemoveFilter = {
  type: SEARCH_REMOVE_FILTER,
  payload: {
    criteria: SearchModelEnum,
    propertyCriteria?: PropertyCriteria,
    value?: string | number
  }
}

type RemoveAllFilter = {
  type: SEARCH_REMOVE_ALL_FILTER
}

type AddSort = {
  type: SEARCH_ADD_SORT,
  payload: {
    sortField: SortField,
    sortDirection: SortDirection
  }
}

export type SearchActionTypes = ChangeCategory | ChangeFolder | AddFilter | RemoveFilter | RemoveAllFilter | AddSort;
export type SearchState = {
  search: SearchModel;
  currentCategory: ContentCategory;
  currentFolderId: number;
  activeFilters: AutoSuggestValue[],
}

const validateOnCategory = (state: SearchState, key: number) => {
  if (!state.currentCategory?.filter?.propertyCriteria)
    return false;

  return Object.keys(state.currentCategory?.filter?.propertyCriteria).includes(key.toString());
}

export const searchReducer = (state: SearchState, action: SearchActionTypes) => {
  let search = state.search;
  switch (action.type) {
    case "CHANGE_CATEGORY":
      search = Object.assign(
        action.payload.filter,
        { deploymentSiteIds: [action.payload.deploymentSiteId] },
        action.payload.rootFolderId === 0
          ? null
          : { folderIds: [action.payload.rootFolderId] }
      );
      search = { ...search, sortFields: [{ sortField: SortField.Id, sortDirection: SortDirection.DESC }] }
      return {
        ...state,
        search,
        currentCategory: action.payload,
        currentFolderId: action.payload.rootFolderId,
        activeFilters: []
      }
    case "CHANGE_FOLDER":
      search = action.payload.id === 0 ? state.search : { ...state.search, folderIds: [action.payload.id], sortFields: [{ sortField: SortField.Id, sortDirection: SortDirection.DESC }] }
      return {
        ...state,
        search,
        currentFolderId: action.payload.id,
      };
    case "ADD_FILTER":
      const { criteria, value, overwrite, propertyCriteria, label, text } = action.payload;
      if (propertyCriteria) {
        let activeFilters: AutoSuggestValue[];
        let oldFilters = state.activeFilters.filter(filter => !filter.propertyCriteria)
        let propertyCriteriaSearch = {};
        if (Array.isArray(propertyCriteria)) {
          propertyCriteriaSearch = propertyCriteria.reduce((acc, cur) => ({ ...acc, [cur.id]: { "operator": cur.operator, "value": cur.value, "systemName": cur.systemName } }), {})
          // @ts-ignore
          activeFilters = propertyCriteria.map(criteria => {
            return {
              searchCriteria: SearchModelEnum.properties,
              propertyCriteria: criteria,
              value: criteria.value,
              label: criteria.label || label,
              labelValue: criteria.value === true ? "Yes" : Array.isArray(criteria.value) ? criteria.value.join(" >> ") : criteria.value
            }
          })
        } else {
          propertyCriteriaSearch = { [propertyCriteria.id]: { "operator": propertyCriteria.operator, "value": propertyCriteria.value, "systemName": propertyCriteria.systemName } }
          activeFilters = [{
            searchCriteria: SearchModelEnum.properties,
            propertyCriteria: propertyCriteria,
            value: propertyCriteria.value,
            // @ts-ignore
            label: propertyCriteria.label || label || "",
            labelValue: propertyCriteria.value === true ? "Yes" : Array.isArray(propertyCriteria.value) ? propertyCriteria.value.join(" >> ") : propertyCriteria.value
          }]
        }
        activeFilters = activeFilters.concat(oldFilters)


        if (state.currentCategory?.filter?.properties && state.currentCategory?.filter?.properties.length > 0) {
          const catgoryProperties = state.currentCategory?.filter?.properties.reduce((acc, cur) => ({ ...acc, [cur.id]: { "operator": cur.operator, "value": cur.value, "systemName": cur.systemName } }), {})
          propertyCriteriaSearch = { ...propertyCriteriaSearch, ...catgoryProperties }
        }
        search = { ...search, sortFields: [{ sortField: SortField.Id, sortDirection: SortDirection.DESC }] }
        return {
          ...state,
          search: {
            ...search,
            properties: propertyCriteriaSearch,
          },
          activeFilters,
        }
      } else {

        let tmpCriterialValue;
        if (overwrite) {
          tmpCriterialValue = [value]
        } else {
          if (!state.search[criteria]) {
            tmpCriterialValue = []
          } else {
            tmpCriterialValue = state.search[criteria];
          }
          if (criteria === SearchModelEnum.folderIds) {
            tmpCriterialValue = tmpCriterialValue.filter((filter: any) => filter !== state.currentFolderId)
          }
          tmpCriterialValue.push(value)
        }

        if (criteria === SearchModelEnum.freeText) {
          search = { ...search, sortFields: [{ sortField: SortField.Relevance, sortDirection: SortDirection.DESC }] }
        }
        else {
          search = { ...search, sortFields: [{ sortField: SortField.Id, sortDirection: SortDirection.DESC }] }
        }

        return {
          ...state,
          search: {
            ...search,
            [criteria]: tmpCriterialValue
          },
          activeFilters: [
            ...state.activeFilters,
            {
              searchCriteria: criteria,
              label: label,
              value: value,
              labelValue: text ?? value,
            }
          ]
        }
      }
    case "REMOVE_FILTER":
      if (action.payload.propertyCriteria) {
        return {
          ...state,
          search: {
            ...state.search,
            // @ts-ignore
            // eslint-disable-next-line eqeqeq
            properties: Object.fromEntries(Object.entries(state.search.properties).filter(([key]) => key != action.payload.propertyCriteria?.id || validateOnCategory(state, action.payload.propertyCriteria?.id))),
          },
          activeFilters: state.activeFilters.filter((activeFilter) => activeFilter.propertyCriteria?.id !== action.payload.propertyCriteria?.id)
        }
      } else {
        switch (action.payload.criteria) {
          case SearchModelEnum.folderIds:
            const existingFolderIds = state.search.folderIds ?? [];
            const updatedFolderIds = existingFolderIds.filter((val: any) => val !== action.payload.value);
            //when there are no user selected filters, add the target filter
            if (updatedFolderIds.length <= 0 && state.currentFolderId !== 0) {
              updatedFolderIds.push(state.currentFolderId);
            }
            if (updatedFolderIds.length > 0) {
              state.search = {
                ...state.search,
                folderIds: updatedFolderIds
              };
            } else {
              //when there is no folder id in the search, we need to remove the folderIds from the search
              const { folderIds, ...remainingSearch } = state.search;
              state.search = remainingSearch;
            }
            return {
              ...state,
              activeFilters: state.activeFilters.filter((activeFilter) => activeFilter.value !== action.payload.value)
            }
          case SearchModelEnum.moodboardIds:
            const existingMoodboardIds = state.search.moodboardIds ?? [];
            const updatedMoodboardIds = existingMoodboardIds.filter((val: any) => val !== action.payload.value);
            if (updatedMoodboardIds.length > 0) {
              state.search = {
                ...state.search,
                moodboardIds: updatedMoodboardIds
              };
            } else {
              //when there is no folder id in the search, we need to remove the folderIds from the search
              const { moodboardIds, ...remainingSearch } = state.search;
              state.search = remainingSearch;
            }
            return {
              ...state,
              activeFilters: state.activeFilters.filter((activeFilter) => activeFilter.value !== action.payload.value)
            }
          default:
            return {
              ...state,
              search: {
                ...state.search,
                [action.payload.criteria]: state.search[action.payload.criteria].filter((val: any) => val !== action.payload.value),
                sortFields: [{ sortField: SortField.Id, sortDirection: SortDirection.DESC }]
              },
              activeFilters: state.activeFilters.filter((activeFilter) => {
                return !(activeFilter.value === action.payload.value && activeFilter.searchCriteria === action.payload.criteria)
              })
            }
        }
      }
    case "REMOVE_ALL_FILTER":
      search = Object.assign(
        state.currentCategory.filter,
        { deploymentSiteIds: [state.currentCategory.deploymentSiteId] },
        state.currentCategory.rootFolderId === 0
          ? null
          : { folderIds: [state.currentCategory.rootFolderId] }
      );
      search = { ...search, sortFields: [{ sortField: SortField.Id, sortDirection: SortDirection.DESC }] }
      return {
        ...state,
        search,
        currentFolderId: state.currentCategory.rootFolderId,
        activeFilters: []
      }
    case "ADD_SORT":
      search = { ...state.search, sortFields: [{ sortField: action.payload.sortField, sortDirection: action.payload.sortDirection }] }
      return {
        ...state,
        search,
      };
    default:
      return state;
  }
};